import React, { memo } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import clsx from 'clsx';
import { UniqueIdentifier } from '@dnd-kit/core';
import { Box } from '@mui/material';

type ContainerProps = {
  id: UniqueIdentifier;
  children: React.ReactNode;
  description?: string;
  onAddItem?: () => void;
  render?: (data: any) => React.ReactNode;
  data?: any;
};

const Column = (props: ContainerProps) => {
  //#region Destructuring Props
  const { id, children, data } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { attributes, setNodeRef, transform, transition, isDragging } = useSortable({
    id: id,
    data: {
      type: 'column',
    },
  });
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box
      {...attributes}
      ref={setNodeRef}
      style={{
        transition,
        transform: CSS.Translate.toString(transform),
      }}
      className={clsx('min-h-[400px] w-full h-full rounded-xl flex flex-col gap-y-4', isDragging && 'opacity-50')}
    >
      <Box className='flex items-center justify-between'>
        {props.render ? props.render(data) : <h1 className='text-gray-800 text-xl'>{data?.name}</h1>}
      </Box>
      <Box className={clsx(!data?.items?.length && 'border rounded-[8px]')}>{children}</Box>
    </Box>
  );
};

export default memo(Column);
